import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import reducer from "./Reducers";

const makeStore = createStore(
  reducer,
  composeWithDevTools(applyMiddleware(thunk))
);

export default makeStore;
